import {OptionIcons} from './schemas.js'

export const getCriterionIcon = (criterion: string, iconsList?: OptionIcons) => {
  if (!iconsList?.criteria) return undefined
  return iconsList.criteria[criterion] || iconsList.criteria.placeholderDefault
}

export const getOptionIcon = (value: string, currentOption: string, iconsList?: OptionIcons) => {
  if (!iconsList) return undefined

  const iconSet = iconsList[currentOption]

  if (!iconSet) return undefined

  return iconSet[value] || iconSet.placeholderDefault
}
